module.exports = __webpack_public_path__ + "c246fa81679df7196e54214f51dcddea.svg";